import React from 'react';
import { Biohazard } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Footer: React.FC = () => {
  const { t } = useTranslation('Footer');

  return (
    <footer className="w-full bg-skjeta-dark border-t border-white/5 py-8 mt-12 pb-24 md:pb-8">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
        <Link to="/" className="flex items-center gap-2 cursor-pointer focus:outline-none focus:ring-2 focus:ring-skjeta-green rounded">
            <Biohazard className="text-skjeta-green w-6 h-6" />
            <span className="font-black italic text-xl tracking-tighter text-white">SKJETA.NO</span>
        </Link>

        <div className="text-sm text-gray-500">
            <p>{t('copyright', { year: new Date().getFullYear() })}</p>
            <p className="text-xs mt-1">{t('tagline')}</p>
        </div>

        <div className="flex gap-4 text-sm font-bold text-gray-400">
            <Link to="/rules" className="hover:text-skjeta-purple transition-colors focus:outline-none focus:ring-2 focus:ring-skjeta-purple rounded">{t('rules')}</Link>
            <Link to="/contact" className="hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white rounded">{t('contact')}</Link>
        </div>
      </div>
    </footer>
  );
};
